export enum BinaryDependencyConfidence {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  Unknown= 'Unknown',
}

const BinaryDependencyConfidenceNumbers = {
  [BinaryDependencyConfidence.Low]: 25,
  [BinaryDependencyConfidence.Medium]: 50,
  [BinaryDependencyConfidence.High]: 75,
};

export const knownBinaryDependencyConfidenceNumbers = Object.values(BinaryDependencyConfidenceNumbers);

/**
 * Convert a number to BinaryDependencyConfidence
 * Assumes that we will only see 25, 50 or 75 - based on CodeSentry results
 */
export function convertToBinaryDependencyConfidence(
  confidence: number,
): BinaryDependencyConfidence {
  if (confidence === BinaryDependencyConfidenceNumbers[BinaryDependencyConfidence.High]) {
    return BinaryDependencyConfidence.High;
  }

  if (confidence === BinaryDependencyConfidenceNumbers[BinaryDependencyConfidence.Medium]) {
    return BinaryDependencyConfidence.Medium;
  }

  if (confidence === BinaryDependencyConfidenceNumbers[BinaryDependencyConfidence.Low]) {
    return BinaryDependencyConfidence.Low;
  }

  return BinaryDependencyConfidence.Unknown;
}

/**
 * Convert a BinaryDependencyConfidence to a number
 */
export function convertToBinaryDependencyConfidenceNumber(
  confidence: BinaryDependencyConfidence,
): number | null {
  switch (confidence) {
    case BinaryDependencyConfidence.High:
      return BinaryDependencyConfidenceNumbers[BinaryDependencyConfidence.High];
    case BinaryDependencyConfidence.Medium:
      return BinaryDependencyConfidenceNumbers[BinaryDependencyConfidence.Medium];
    case BinaryDependencyConfidence.Low:
      return BinaryDependencyConfidenceNumbers[BinaryDependencyConfidence.Low];
    case BinaryDependencyConfidence.Unknown:
      return null;
    default:
      throw new Error(`Unknown BinaryDependencyConfidence: ${confidence}`);
  }
}
